/*
 * The meta line under an article's or a news item's title: when it was
 * written, when it last changed and who wrote it. Both pages build it here so
 * they read the same.
 */

function toDate(seconds) {
  const value = Number(seconds);

  if (!seconds || Number.isNaN(value)) {
    return null;
  }

  const date = new Date(value * 1000);

  return Number.isNaN(date.getTime()) ? null : date;
}

function formatDate(date, locale) {
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
}

export function buildPublicationMeta(publication, t, locale) {
  const meta = [];

  const created = toDate(publication.creation_date);
  const modified = toDate(publication.modified_date);

  if (created) {
    meta.push({
      key: 'created',
      icon: 'fa-regular fa-calendar',
      text: formatDate(created, locale),
    });
  }

  // Same day as the creation is not worth a second date.
  if (modified && (!created || formatDate(modified, locale) !== formatDate(created, locale))) {
    meta.push({
      key: 'updated',
      icon: 'fa-regular fa-pen-to-square',
      text: t('pageHeader.updated', { date: formatDate(modified, locale) }),
    });
  }

  const authorName =
    publication.author?.name?.trim() || publication.author?.nickname?.trim();

  if (authorName) {
    meta.push({
      key: 'author',
      icon: 'fa-regular fa-user',
      text: t('pageHeader.byAuthor', { name: authorName }),
      href: publication.author.mail ? `mailto:${publication.author.mail}` : undefined,
    });
  }

  return meta;
}
